<template>
  <v-container fluid class="text-center">
    <v-card class="elevation-5 mt-5">
      <v-toolbar dense dark color="secondary" elevation="2">
        <v-toolbar-title> Eventos </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text small :disabled="loading || !isWriting" @click="dialogs.new = true">
          Agregar
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-title>
        <v-btn small :loading="loading" :disabled="!isReading" elevation="0" color="secondary" outlined class="mx-2" @click="refresh()">
          Actualizar
          <v-icon right>mdi-refresh</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" class="mx-2" single-line hide-details maxlength="150"></v-text-field>
      </v-card-title>
      <v-data-table v-model="selected" :headers="headers" :items="items" :loading="loading" :search="search"
      :footer-props="{ 'items-per-page-text': 'Elementos por página', 'items-per-page-options': [20, 50, -1] }" :items-per-page="10" item-key="id" class="elevation-1" dense>
        <v-progress-linear slot="progress" color="secondary" indeterminate></v-progress-linear>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="mr-2" size="22" color="primary" dark v-bind="attrs" v-on="on" :disabled="loading" @click="view(item)">mdi-pencil</v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="mr-2" size="22" color="red" dark v-bind="attrs" v-on="on" :disabled="loading" @click="remove(item.eventoID)">mdi-delete</v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
        </template>
        <template v-slot:footer.page-text="props"> Página {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }} </template>
        <template v-slot:no-data> No hay información disponible </template>
        <template v-slot:no-results> No se obtuvieron resultados </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="dialogs.new" persistent max-width="600px">
      <v-card>
        <v-toolbar dense dark color="secondary" elevation="2">
          <v-toolbar-title>Nuevo evento</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn text small :disabled="loading" @click="cancel()">
            Cerrar
            <v-icon right>mdi-close</v-icon>
          </v-btn>
          <v-btn text small :loading="loading" :disabled="!isWriting" @click="save()">
            Guardar
            <v-icon right>mdi-check</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-form ref="formNew" lazy-validation>
              <v-row>
                <v-col cols="12">
                  <v-text-field v-model="forms.new.nombre" label="Nombre" :rules="rules.nombre" :disabled="loading" required></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete v-model="forms.new.ubicacion" :items="catalogues.ubicaciones" item-text="nombre" item-value="lda_ubicacionID" label="Ubicación" :rules="rules.ubicacion" :disabled="loading" dense persistent-hint></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <v-dialog ref="startDateDialog" v-model="dialogs.startDate" :return-value.sync="forms.new.fechaInicio" persistent width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="forms.new.fechaInicio" label="Fecha inicio" :rules="rules.fechaInicio" readonly v-bind="attrs" v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="forms.new.fechaInicio" locale="es" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="dialogs.startDate = false">
                        Cancelar
                      </v-btn>
                      <v-btn text color="primary" @click="$refs.startDateDialog.save(forms.new.fechaInicio)">
                        Aceptar
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
                <v-col cols="12" md="6">
                  <v-dialog ref="startHourDialog" v-model="dialogs.startHour" :return-value.sync="forms.new.horaInicio" persistent width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="forms.new.horaInicio" label="Hora inicio" :rules="rules.horaInicio" readonly v-bind="attrs" v-on="on"></v-text-field>
                    </template>
                    <v-time-picker v-model="forms.new.horaInicio" locale="es" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="dialogs.startHour = false">
                        Cancelar
                      </v-btn>
                      <v-btn text color="primary" @click="$refs.startHourDialog.save(forms.new.horaInicio)">
                        Aceptar
                      </v-btn>
                    </v-time-picker>
                  </v-dialog>
                </v-col>
                <v-col cols="12" md="6">
                  <v-dialog ref="endDateDialog" v-model="dialogs.endDate" :return-value.sync="forms.new.fechaFin" persistent width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="forms.new.fechaFin" label="Fecha Fin" :rules="rules.fechaFin" readonly v-bind="attrs" v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="forms.new.fechaFin" locale="es" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="dialogs.endDate = false">
                        Cancelar
                      </v-btn>
                      <v-btn text color="primary" @click="$refs.endDateDialog.save(forms.new.fechaFin)">
                        Aceptar
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
                <v-col cols="12" md="6">
                  <v-dialog ref="endHourDialog" v-model="dialogs.endHour" :return-value.sync="forms.new.horaFin" persistent width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="forms.new.horaFin" label="Hora Fin" :rules="rules.horaFin" readonly v-bind="attrs" v-on="on"></v-text-field>
                    </template>
                    <v-time-picker v-model="forms.new.horaFin" locale="es" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="dialogs.endHour = false">
                        Cancelar
                      </v-btn>
                      <v-btn text color="primary" @click="$refs.endHourDialog.save(forms.new.horaFin)">
                        Aceptar
                      </v-btn>
                    </v-time-picker>
                  </v-dialog>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete v-model="forms.new.instructor" :items="catalogues.instructores" item-text="nombre" item-value="instructorID" label="Instructor" :rules="rules.instructor" :disabled="loading" dense persistent-hint></v-autocomplete>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="forms.new.capacidadMaxima" label="Capacidad Máxima" :rules="rules.capacidadMaxima" :disabled="loading" required></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="forms.new.codigoAcceso" label="Código de Acceso" :rules="rules.codigoAcceso" :disabled="loading" required></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogs.update" persistent max-width="600px">
      <v-card>
        <v-toolbar dense dark color="secondary" elevation="2">
          <v-toolbar-title>Actualizar evento</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn text small :disabled="loading" @click="cancel()">
            Cerrar
            <v-icon right>mdi-close</v-icon>
          </v-btn>
          <v-btn text small :loading="loading" :disabled="!isWriting" @click="update()">
            Actualizar
            <v-icon right>mdi-check</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-form ref="formUpdate" lazy-validation>
              <v-row>
                <v-col cols="12">
                  <v-text-field v-model="forms.update.nombre" label="Nombre" :rules="rules.nombre" :disabled="loading" required></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete v-model="forms.update.ubicacion" :items="catalogues.ubicaciones" item-text="nombre" item-value="lda_ubicacionID" label="Ubicación" :rules="rules.ubicacion" :disabled="loading" dense persistent-hint></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <v-dialog ref="startDateDialog" v-model="dialogs.startDate" :return-value.sync="forms.update.fechaInicio" persistent width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="forms.update.fechaInicio" label="Fecha inicio" :rules="rules.fechaInicio" readonly v-bind="attrs" v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="forms.update.fechaInicio" locale="es" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="dialogs.startDate = false">
                        Cancelar
                      </v-btn>
                      <v-btn text color="primary" @click="$refs.startDateDialog.save(forms.update.fechaInicio)">
                        Aceptar
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
                <v-col cols="12" md="6">
                  <v-dialog ref="startHourDialog" v-model="dialogs.startHour" :return-value.sync="forms.update.horaInicio" persistent width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="forms.update.horaInicio" label="Hora inicio" :rules="rules.horaInicio" readonly v-bind="attrs" v-on="on"></v-text-field>
                    </template>
                    <v-time-picker v-model="forms.update.horaInicio" locale="es" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="dialogs.startHour = false">
                        Cancelar
                      </v-btn>
                      <v-btn text color="primary" @click="$refs.startHourDialog.save(forms.update.horaInicio)">
                        Aceptar
                      </v-btn>
                    </v-time-picker>
                  </v-dialog>
                </v-col>
                <v-col cols="12" md="6">
                  <v-dialog ref="endDateDialog" v-model="dialogs.endDate" :return-value.sync="forms.update.fechaFin" persistent width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="forms.update.fechaFin" label="Fecha Fin" :rules="rules.fechaFin" readonly v-bind="attrs" v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="forms.update.fechaFin" locale="es" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="dialogs.endDate = false">
                        Cancelar
                      </v-btn>
                      <v-btn text color="primary" @click="$refs.endDateDialog.save(forms.update.fechaFin)">
                        Aceptar
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
                <v-col cols="12" md="6">
                  <v-dialog ref="endHourDialog" v-model="dialogs.endHour" :return-value.sync="forms.update.horaFin" persistent width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="forms.update.horaFin" label="Hora Fin" :rules="rules.horaFin" readonly v-bind="attrs" v-on="on"></v-text-field>
                    </template>
                    <v-time-picker v-model="forms.update.horaFin" locale="es" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="dialogs.endHour = false">
                        Cancelar
                      </v-btn>
                      <v-btn text color="primary" @click="$refs.endHourDialog.save(forms.update.horaFin)">
                        Aceptar
                      </v-btn>
                    </v-time-picker>
                  </v-dialog>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete v-model="forms.update.instructor" :items="catalogues.instructores" item-text="nombre" item-value="instructorID" label="Instructor" :rules="rules.instructor" :disabled="loading" dense persistent-hint></v-autocomplete>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="forms.update.capacidadMaxima" label="Capacidad Máxima" :rules="rules.capacidadMaxima" :disabled="loading" required></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="forms.update.codigoAcceso" label="Código de Acceso" :rules="rules.codigoAcceso" :disabled="loading" required></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogs.remove" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Aviso</v-card-title>
        <v-card-text>¿Realmente desea eliminar el evento?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text small :disabled="loading" color="blue-grey" @click="cancel()">
            Cancelar
          </v-btn>
          <v-btn text small :loading="loading" color="error" @click="remove()">
            Eliminar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="success" color="success" :timeout="2500" bottom right>
      {{ msgSuccess }}
    </v-snackbar>
    <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
      {{ msgError }}
    </v-snackbar>
  </v-container>
</template>

<script>
import services from "@/utils/services";
import moment from "moment-timezone";

export default {
  name: "events",
  data: () => ({
    loading: false,
    success: false,
    msgSuccess: "",
    error: false,
    msgError: "",
    search: "",
    headers: [
      { text: "ID", align: "left", sortable: false, value: "eventoID" },
      { text: "Nombre", align: "left", sortable: false, value: "nombre" },
      { text: "Ubicación", align: "left", sortable: false, value: "ubicacion.nombre" },
      { text: "Fecha Inicio", align: "left", sortable: false, value: "fecha_hora_inicio" },
      { text: "Fecha Fin", align: "left", sortable: false, value: "fecha_hora_fin" },
      { text: "Instructor", align: "left", sortable: false, value: "nombre_instructor" },
      { text: "Capacidad Máxima", align: "left", sortable: false, value: "capacidadMaxima" },
      { text: "Acciones", align: "left", sortable: false, value: "actions" },
    ],
    items: [],
    selected: [],
    catalogues: {
      ubicaciones: [],
      instructores: []
    },
    forms: {
      new: {
        nombre: '',
        ubicacion: '',
        fechaInicio: '',
        horaInicio: '',
        fechaFin: '',
        horaFin: '',
        instructor: '',
        capacidadMaxima: '',
        codigoAcceso: ''
      },
      update: {
        eventoID: '',
        nombre: '',
        ubicacion: '',
        fechaInicio: '',
        horaInicio: '',
        fechaFin: '',
        horaFin: '',
        instructor: '',
        capacidadMaxima: '',
        codigoAcceso: ''
      },
    },
    rules: {
      nombre: [
        v => !!v || 'El campo es requerido',
        v => (v && v.length <= 200) || 'El campo excede la longitud máxima'
      ],
      ubicacion: [
        v => !!v || 'El campo es requerido'
      ],
      fechaInicio: [
        v => !!v || 'El campo es requerido'
      ],
      horaInicio: [
        v => !!v || 'El campo es requerido'
      ],
      fechaFin: [
        v => !!v || 'El campo es requerido'
      ],
      horaFin: [
        v => !!v || 'El campo es requerido'
      ],
      instructor: [
        v => !!v || 'El campo es requerido'
      ],
      capacidadMaxima: [
        v => !!v || 'El campo es requerido',
        v => /^\d{1,5}$/.test(v) || 'El campo es inválido'
      ],
      codigoAcceso: [
        v => !!v || 'El campo es requerido',
        v => (v && v.length <= 100) || 'El campo excede la longitud máxima'
      ],
    },
    dialogs: {
      new: false,
      update: false,
      remove: false,
      startDate: false,
      startHour: false,
      endDate: false,
      endHour: false
    },
  }),
  mounted() {
    if (this.isReading) {
      this.refresh()
    }
  },
  computed: {
    isReading: function () {
      return services.check(1, this.$route.path);
    },
    isWriting: function () {
      return services.check(2, this.$route.path);
    },
    isRemoving: function() {
      return services.check(3, this.$route.path);
    }
  },
  methods: {
    async refresh() {
      this.loading = true;
      const location = await this.axios.get(services.routes.ubicaciones)
      if (location.data.data) {
        this.catalogues.ubicaciones = location.data.data
      }
      const instructor = await this.axios.get(services.routes.instructores)
      if (instructor.data.data) {
        this.catalogues.instructores = instructor.data.data
      }
      this.axios.get(services.routes.eventos)
        .then((response) => {
          this.items = response.data.data;
          for (let i = 0; i < this.items.length; i++) {
            this.items[i].fecha_hora_inicio = moment.tz(this.items[i].fechaInicio, 'UTC').local().format('YYYY-MM-DD HH:mm')
            this.items[i].fecha_hora_fin = moment.tz(this.items[i].fechaFin, 'UTC').local().format('YYYY-MM-DD HH:mm')
            this.items[i].nombre_instructor = (this.items[i].instructor.nombre + " " + this.items[i].instructor.apellidoPaterno + " " + this.items[i].instructor.apellidoMaterno).trim();
          }
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    cancel() {
      if (this.dialogs.new) {
        this.$refs.formNew.reset()
        for (let key in this.forms.new) {
          this.forms.new[key] = ''
        }
        this.dialogs.new = false
      }
      else if (this.dialogs.update) {
        this.$refs.formUpdate.reset()
        for (let key in this.forms.update) {
          this.forms.update[key] = ''
        }
        this.dialogs.update = false
      }
      else if (this.dialogs.remove) {
        this.dialogs.remove = false
      }
    },
    save() {
      if (this.$refs.formNew.validate()) {
        this.loading = true
        let data = JSON.parse(JSON.stringify(this.forms.new))
        data.fechaInicio = moment.utc(moment(data.fechaInicio + ' ' + data.horaInicio)).format()
        data.fechaFin = moment.utc(moment(data.fechaFin + ' ' + data.horaFin)).format()
        data.capacidadMaxima = parseInt(data.capacidadMaxima)
        this.axios.post(services.routes.eventos, { data })
          .then(response => {
            this.cancel()
            this.refresh()
            this.success = true
            this.msgSuccess = 'Evento guardado exitosamente'
          })
          .catch(error => {
            this.error = true
            this.msgError = error.response.data.message || 'Servicio no disponible'
          })
          .finally(() => {
            this.loading = false
          })
      }
      else {
        this.error = true
        this.msgError = 'La información es incorrecta'
      }
    },
    view(data) {
      let startDate = moment.tz(data.fechaInicio, 'UTC').local().format('YYYY-MM-DD')
      let startHour = moment.tz(data.fechaInicio, 'UTC').local().format('HH:mm')
      let endDate = moment.tz(data.fechaFin, 'UTC').local().format('YYYY-MM-DD')
      let endHour = moment.tz(data.fechaFin, 'UTC').local().format('HH:mm')
      this.forms.update = {
        eventoID: data.eventoID,
        nombre: data.nombre,
        ubicacion: data.ubicacion.lda_ubicacionID,
        fechaInicio: startDate,
        horaInicio: startHour,
        fechaFin: endDate,
        horaFin: endHour,
        instructor: data.instructor.instructorID,
        capacidadMaxima: data.capacidadMaxima,
        codigoAcceso: data.codigoAcceso
      }
      this.dialogs.update = true
    },
    update() {
      if (this.$refs.formUpdate.validate()) {
        this.loading = true
        let data = JSON.parse(JSON.stringify(this.forms.update))
        data.fechaInicio = moment.utc(moment(data.fechaInicio + ' ' + data.horaInicio)).format()
        data.fechaFin = moment.utc(moment(data.fechaFin + ' ' + data.horaFin)).format()
        data.capacidadMaxima = parseInt(data.capacidadMaxima)
        this.axios.put(services.routes.eventos, { data })
          .then(response => {
            this.cancel()
            this.refresh()
            this.success = true
            this.msgSuccess = 'Evento actualizado exitosamente'
          })
          .catch(error => {
            this.error = true
            this.msgError = error.response.data.message || 'Servicio no disponible'
          })
          .finally(() => {
            this.loading = false
          })
      }
      else {
        this.error = true
        this.msgError = 'La información es incorrecta'
      }
    },
    remove(id) {
      if (!id) {
        this.loading = true
        this.axios.delete(services.routes.eventos, { data: { data: { eventoID: this.deleted } } })
          .then(response => {
            this.cancel()
            this.refresh()
            this.success = true
            this.msgSuccess = 'Evento eliminado exitosamente'
          })
          .catch(error => {
            this.error = true
            this.msgError = error.response.data.message || 'Servicio no disponible'
          })
          .finally(() => {
            this.loading = false
          })
      }
      else {
        this.deleted = id
        this.dialogs.remove = true
      }
    }
  },
};
</script>

<style scoped>
</style>
